import { FunctionComponent } from "react";
import { Trans } from "react-i18next";
import { Text } from "@ui-kit/Text/Text";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { selectAuthView } from "@store/sessionReducer";
import { useAppSelector } from "@store/store";

interface AuthInstructionsProps {
  values?: Record<string, string>;
}

const AuthInstructions: FunctionComponent<AuthInstructionsProps> = ({
  values = {},
}) => {
  const view = useAppSelector(selectAuthView);

  return (
    <div className="auth-description">
      <Text variant="fontBodyLarge" color={colors.textSecondary}>
        <Trans i18nKey={`screens.auth.${view}.description`} values={values} />
      </Text>
    </div>
  );
};

export { AuthInstructions };
